// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"6c2a3f3c","320":"1aa51462","488":"dab9192e","604":"e0487c8f","616":"9b9e60a7","849":"5eeec768","875":"1aec9dc3","950":"50179253"}[chunkId] + ".chunk.js";
};